<div class='grid-wrapper'>

  <div class="search-toolbar example-box" kendoTooltip position="top">
    <div class="search-toolbar-inner">
      <!-- Left cluster: input + actions -->
      <div class="search-input-wrap">
        <span class="search-input-icon" aria-hidden="true">
          <i class="ms-Icon ms-Icon--Search"></i>
        </span>
        <input
          type="text"
          class="search-input"
          [(ngModel)]="searchText"
          (keyup)="this.onKeyEvent($event)"
          placeholder="Search by definition"
          aria-label="Search flows"
          />
        @if (searchText) {
          <button
            type="button"
            class="search-input-clear"
            (click)="searchText = ''; onSearch()"
            title="Clear search"
            aria-label="Clear search">
            <i class="ms-Icon ms-Icon--Clear" aria-hidden="true"></i>
          </button>
        }
      </div>
      <button type="button"
        class="inline-flex items-center gap-1.5 rounded-lg shadow border-0 cursor-pointer px-3 py-1.5 text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-600"
        (click)="onSearch()"
        [disabled]="!this.searchText"
        title="Full-text search">
        <i class="ms-Icon ms-Icon--Search" aria-hidden="true"></i>
        <span>Search</span>
      </button>
      <button type="button"
        class="inline-flex items-center gap-1.5 rounded-lg shadow border-0 cursor-pointer px-3 py-1.5 text-xs font-medium text-slate-600 bg-white hover:bg-slate-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white"
        (click)="onRegexSearch()"
        [disabled]="!this.searchText"
        title="Search by regular expression">
        <i class="ms-Icon ms-Icon--RegistryEditor" aria-hidden="true"></i>
        <span>RegEx</span>
      </button>

      <!-- Right cluster: help link + PRO badge -->
      <div class="search-toolbar-meta">
        <a class="search-toolbar-help"
          href="https://learn.flowstudio.app/full-text-search"
          target="learn"
          title="Learn about Full Text Search">
          <fa-icon icon="user-graduate"></fa-icon>
          <span>Full Text Search</span>
        </a>
        <span class="pro-box" title="Search is a Pro subscription feature"></span>
      </div>
    </div>
  </div>

  <kendo-grid class="flows-search"
    [data]="view"
    [sortable]="true"
    filterable="menu"
    [scrollable]="'virtual'"

    [rowHeight]="32"
    [resizable]="true"
    (dataStateChange)="dataStateChange($event)"

    [filter]="state.filter"
    [sort]="state.sort"
    [skip]="state.skip"
    [pageSize]="100"
    [pageable]="true"

    [selectable]="true"
    [kendoGridSelectBy]="'flowName'"
    #grid>
    <ng-template kendoGridNoRecordsTemplate>
      {{ !this.ready ? "Loading search index..." : this.statusText }}
    </ng-template>
    <!-- <kendo-grid-column field="flowName" title="Flow Name" [width]="75" >
  </kendo-grid-column> -->
  <kendo-grid-column field="shareOwners" title="Owner" [width]="30" [minResizableWidth]="30" [style]="{'min-width': '25px'}" class="cell">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <div>
        <multicheck-filter
          [isPrimitive]="false"
          [field]="column.field"
          [filterService]="filterService"
          [currentFilter]="filter"
          [data]="allOwners | async"
          [textField]="'text'"
          [valueField]="'value'"
        ></multicheck-filter>
      </div>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      @if (dataItem.sharingType.includes('Coauthor')) {
        <span class='ms-Icon ms-Icon--People'
          [title]="'Shared Flow' + (resolveOwners(dataItem) ? ' - owner: ' + resolveOwners(dataItem) : '')"
        [ngStyle]="{'color': dataItem.userType == 'Owner' ? 'green': 'black' }"></span>
      }
      @if (dataItem.sharingType.includes('DelegatedAuth')) {
        <span class='ms-Icon ms-Icon--PeopleExternalShare'
          [title]="'Resource Owner' + (resolveOwners(dataItem) ? ' - owner: ' + resolveOwners(dataItem) : '')"
        [ngStyle]="{'color': dataItem.userType == 'Owner' ? 'dodgerblue': 'black' }"></span>
      }
      @if (dataItem.isManaged && (dataItem.sharingType.includes('CommonDataService') || dataItem.solution)) {
        <span class="cds-managed-stack"
          [title]="'Solution Aware (managed - locked from edits)' + (resolveOwners(dataItem) ? ' - owner: ' + resolveOwners(dataItem) : '')">
          <i class="ms-Icon ms-Icon--CommonDataServiceCDS cds-managed-bg"></i>
          <i class="ms-Icon ms-Icon--LockSolid cds-managed-lock"></i>
        </span>
      }
      @if ((dataItem.sharingType.includes('CommonDataService') || dataItem.solution) && !dataItem.isManaged) {
        <i class="ms-Icon ms-Icon--CommonDataServiceCDS"
          [title]="'Solution Aware' + (resolveOwners(dataItem) ? ' - owner: ' + resolveOwners(dataItem) : '')"
        [ngStyle]="{'color': '#742873' }"></i>
      }
      @if (dataItem.isManaged && !(dataItem.sharingType.includes('CommonDataService') || dataItem.solution)) {
        <i class="ms-Icon ms-Icon--LockSolid" title="Managed solution flow - locked from edits in this environment"
        [ngStyle]="{'color': '#8a8886' }"></i>
      }
      @if (hasSingleOwner(dataItem)) {
        <svg class="fluent-icon"
          viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <title>{{ resolveOwners(dataItem) }}</title>
          <path d="M11.5 8c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4-3.14 0-5-2.03-5-4v-.5C3 8.67 3.67 8 4.5 8h7Zm0 1h-7a.5.5 0 0 0-.5.5v.5c0 1.44 1.43 3 4 3 2.57 0 4-1.56 4-3v-.5a.5.5 0 0 0-.5-.5ZM8 1.5A2.75 2.75 0 1 1 8 7a2.75 2.75 0 0 1 0-5.5Zm0 1A1.75 1.75 0 1 0 8 6a1.75 1.75 0 0 0 0-3.5Z"/>
        </svg>
      }
      @if (dataItem.owners?.length > 1) {
        <svg class="fluent-icon"
          viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <title>{{ resolveOwners(dataItem) }}</title>
          <path d="M6 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm3 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-9-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM3 4.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM4.27 7A2 2 0 0 0 4 8H2v2.5a1.5 1.5 0 0 0 2.1 1.38c.07.33.19.64.34.94A2.5 2.5 0 0 1 1 10.5V8a1 1 0 0 1 1-1h2.27Zm7.3 5.82A2.5 2.5 0 0 0 15 10.5V8a1 1 0 0 0-1-1h-2.27A2 2 0 0 1 12 8h2v2.5a1.5 1.5 0 0 1-2.1 1.38c-.07.33-.19.64-.34.94ZM6 7a1 1 0 0 0-1 1v3a3 3 0 0 0 6 0V8a1 1 0 0 0-1-1H6Zm0 1h4v3a2 2 0 0 1-4 0V8Z"/>
        </svg>
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="displayName" title="Display Name" [width]="200" class="cell">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <!-- <link class="k-icon k-i-plus" (click)="doGetRuns(dataItem)" style="cursor: pointer;" title="Open Runs" *ngIf="dataItem.runsCount" /> -->
      <a href="{{this.apiRoot}}/manage/environments/{{this.environment}}/flows/{{dataItem.sharingType=='Coauthor'?'shared/':''}}{{dataItem.flowName}}/details"
        title="Maker Portal: /manage/environments/{{this.environment}}/flows/{{dataItem.flowName}}" target="_blank">
        <span style="margin-right: 5px;">{{dataItem.displayName}}</span>
        <!-- <span class='k-icon k-i-edit hover-only' style="margin-right: 5px;"></span> -->
      </a>

      <!-- <span class='k-icon k-i-clock hover-only' style="margin-right: 5px;" (click)="doGetRuns(dataItem)" style="cursor: pointer;"
    title="Open Runs"></span> -->

  </ng-template>
  <ng-template kendoGridFooterTemplate let-column="column">
    <span title='Total Flows'>{{this.flows?.length}}&nbsp;of {{this.all?.length}}</span>
    @if (!(this.ready)) {
      <span><span class='k-icon k-i-loading' title='loading search index'></span>...</span>
    }
    <!-- <span *ngIf="this.flowsLoaded$ | async" class='k-icon k-i-refresh' title='click to reload runs' (click)='this.reload()' style="cursor: pointer;" ></span> -->
    <!--<span>(cache:{{this.cache.flows}},{{this.cache.runs}}<span (click)='this.clearRuns()'>x</span>,{{this.cache.settings}})&nbsp;</span>-->
    <span style="margin-left: 6px;">{{ statusText }}</span>

    @if (this.hasFilter) {
      <span title="click to clear filter" style="text-decoration: underline; cursor: pointer;"
        (click)="this.clearFilter()"><span class='ms-Icon ms-Icon--ClearFilter'></span> Results are filtered</span>
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="tags" title="Tags" [width]="80" [minResizableWidth]="80" class="cell" [style]="{'min-width': '50px'}">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter
        [isPrimitive]="true"
        [field]="column.field"
        [filterService]="filterService"
        [currentFilter]="filter"
        [data]="flowTags"
      ></multicheck-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      @if (this.bgColor(dataItem)) {
        <div style="width:20px;height:20px;display:inline-block;vertical-align:middle; margin-right:3px;"
        [style.background-color]='this.bgColor(dataItem)'>&nbsp;</div>
      }
      @for (tag of dataItem.tags; track tag) {
        <span style='margin-right:5px;'><a class='flow-tag cell-filter' href='javascript:void(0)'
        (click)='this.filterByTag(tag)'>{{tag}}</a></span>
      }
      <!-- <span class='k-icon k-i-plus-outline hover-only' style="margin-right: 5px; cursor: pointer;" (click)="doTags(dataItem)"
    title="Change Tags"></span> -->
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="trigger" title="Trigger" [width]="50" [minResizableWidth]="50" [style]="{'min-width': '50px'}">
  <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
    <kendo-multiselect style="width:220px" [data]="flowTriggers" [valuePrimitive]="true" [value]="multiFilters(filter)"
      [autoClose]="false"
      (valueChange)="multiChange($event, filterService, 'trigger', 'eq')">
    </kendo-multiselect>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <div class='cell cell-filter' title='{{dataItem.triggerTooltip || dataItem.trigger}}' (click)='this.filterByTrigger(dataItem.trigger)'><img
      [src]='this.getTriggerIcon(dataItem)' style='width:20px; height:20px; vertical-align:middle;' />
  {{dataItem.trigger}}</div>
</ng-template>
</kendo-grid-column>
<kendo-grid-column field="triggerKind" title="Kind" [width]="50" [minResizableWidth]="50" [style]="{'min-width': '50px'}">
  <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
    <kendo-multiselect style="width:220px" [data]="flowTriggerKinds" [valuePrimitive]="true" [value]="multiFilters(filter)"
      [autoClose]="false"
      (valueChange)="multiChange($event, filterService, 'triggerKind', 'eq')">
    </kendo-multiselect>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <div class='cell cell-filter' title='{{dataItem.triggerTooltip || dataItem.triggerKind}}' (click)='this.filterByTriggerKind(dataItem.triggerKind)'>{{dataItem.triggerKind}}</div>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="actionsCount" title="Actions" [width]="25" [minResizableWidth]="25" type="number" filter="numeric"
  [filterable]="false" [style]="{'min-width': '25px'}">
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title='{{dataItem.actionsTooltip}}'>{{dataItem.actionsCount}}</span>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="flowState" title="State" [width]="30" [minResizableWidth]="30" [style]="{'min-width': '30px'}">
  <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
    <kendo-multiselect style="width:220px" [data]="flowStates" [valuePrimitive]="true" [value]="multiFilters(filter)"
      [autoClose]="false"
      (valueChange)="multiChange($event, filterService, 'flowState', 'eq')">
    </kendo-multiselect>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    @switch (dataItem.flowState) {
      @case ('Started') {
        <span class='cell cell-filter' style='color:green;'
          (click)='this.filterByFlowState(dataItem.flowState)' title='Started'>
          <i class="ms-Icon ms-Icon--PowerButton" style='font-weight:bold;' aria-hidden="true"></i>
        </span>
      }
      @case ('Stopped') {
        <span class='cell cell-filter' style='color:gray'
          (click)='this.filterByFlowState(dataItem.flowState)' title='Stopped'>
          <i class="ms-Icon ms-Icon--Blocked2" style='font-weight:bold;' aria-hidden="true"></i>
        </span>
      }
      @case ('Deleted') {
        <span class='cell cell-filter' style='color:red'
          (click)='this.filterByFlowState(dataItem.flowState)' title='Deleted'>
          <i class="ms-Icon ms-Icon--Blocked2" style='font-weight:bold;' aria-hidden="true"></i>
        </span>
      }
      @case ('Suspended') {
        <span class='cell cell-filter' style='color:red'
          (click)='this.filterByFlowState(dataItem.flowState)' [title]="('Suspended: ')+(dataItem.flowSuspensionReason)">
          <i class="ms-Icon ms-Icon--ShieldAlert" style='font-weight:bold;' aria-hidden="true"></i>
        </span>
      }
      @default {
        <span>{{dataItem.flowState}}</span>
      }
    }
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="modified" title="Last Modified" [width]="60" [minResizableWidth]="60" type="date" format="{0:y-MM-dd HH:mm}"
  filter="date" class="cell" [style]="{'min-width': '65px'}">
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title="{{dataItem.modified|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.modified|date:'y-MM-dd HH:mm'}}</span>
  </ng-template>
</kendo-grid-column>
<!-- <kendo-grid-column field="runsSort" title="Runs" [width]="35" [minResizableWidth]="35" type="number" filter="number"
filterable="false" class="cell" [style]="{'min-width': '25px'}">
<ng-template kendoGridCellTemplate let-dataItem>
  <span title="Estimated run rate per month {{dataItem.runsEstimate|number:'1.0-0'}}">{{dataItem.runsCount}}<span
    *ngIf="dataItem.more" title='There are more pages of runs.'>+</span><span *ngIf="dataItem.runsEstimate>1000">!</span></span>
  </ng-template>
  <ng-template kendoGridFooterTemplate let-column="column">
    <span title='Total Runs Loaded'>{{this.runsCountTotal}}</span>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="runsFailCount" title="Fails" [width]="25" [minResizableWidth]="25" type="number" filter="number"
  filterable="false" [style]="{'min-width': '25px'}">
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title="{{ dataItem.runsCount? ((dataItem.runsFailCount/dataItem.runsCount) | percent) : ''}}">{{dataItem.runsFailCount}}</span>
  </ng-template>
  <ng-template kendoGridFooterTemplate let-column="column">
    <span title='Total Fails Loaded'>{{this.runsFailCountTotal}}</span>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="lastRun" title="Last Ran" [width]="60" [minResizableWidth]="60" type="date" format="{0:y-MM-dd HH:mm}"
  filter="date" class="cell" [style]="{'min-width': '65px'}">
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title="{{dataItem.lastRun|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.lastRun|date:'y-MM-dd HH:mm'}}</span>
  </ng-template>
</kendo-grid-column> -->
<!-- <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="this.hasRuns">
<app-flow-runs [flow]="dataItem" [runs]="dataItem.runsLoaded" [nested]="true"></app-flow-runs>
</ng-template> -->
<!-- <kendo-grid-excel fileName="flows.xlsx"></kendo-grid-excel> -->
</kendo-grid>
@if (!this.ready) {
  <div class="loading">
    <div class="k-i-loading"></div>
  </div>
}
<!-- <grid-context-menu [for]="grid" [menuItems]="['Enable', 'Disable', 'Edit JSON']" (select)="onSelect($event)"></grid-context-menu> -->
</div>
